// import React, { useState, useEffect } from "react";
// import "./AttendancePortal.css";
// import Navbar from "./common/Navbar";
// import Footer from "./common/Footer";
// import Sidebar from "./common/Sidebar";
// import { useNavigate } from "react-router-dom";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const AttendancePortal = () => {
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");
//   const [isLoggedIn, setIsLoggedIn] = useState(
//     !!sessionStorage.getItem("token")
//   );
//   const [currentTime, setCurrentTime] = useState(new Date());
//   const [checkInTime, setCheckInTime] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   // Get current date and day
//   const today = new Date();
//   const formattedDate = today
//     .toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     })
//     .toUpperCase();
//   const formattedDay = today.toLocaleDateString("en-GB", {
//     weekday: "long",
//   });

//   // Update the time every second
//   useEffect(() => {
//     const intervalId = setInterval(() => {
//       setCurrentTime(new Date());
//     }, 1000);

//     fetchCheckInTime();

//     return () => clearInterval(intervalId);
//   }, []);

//   const formatTime = (date) => {
//     if (!date) return "--:--:--";
//     const hours = date.getHours().toString().padStart(2, "0");
//     const minutes = date.getMinutes().toString().padStart(2, "0");
//     const seconds = date.getSeconds().toString().padStart(2, "0");
//     return `${hours}:${minutes}:${seconds}`;
//   };

//   const fetchCheckInTime = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) return;

//       const decodedToken = JSON.parse(atob(token.split(".")[1]));
//       const employeeId = decodedToken.employee.id;

//       const response = await fetch(
//         `${BASE_URL}/api/attendance/checkin-time/${employeeId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.ok) {
//         const data = await response.json();
//         setCheckInTime(data.checkInTime ? new Date(data.checkInTime) : null);
//       }
//     } catch (err) {
//       console.error("Error fetching check-in time:", err);
//     }
//   };

//   const handleCheckIn = async () => {
//     try {
//       setIsLoading(true);
//       const token = sessionStorage.getItem("token");
//       const decodedToken = JSON.parse(atob(token.split(".")[1]));
//       const employeeId = decodedToken.employee.id;

//       const response = await fetch(`${BASE_URL}/api/attendance/checkin`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ employeeId }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         setMessage(data.msg);
//         setError("");
//         setCheckInTime(new Date());
//       } else {
//         setError(data.message || "Check-in failed");
//       }
//     } catch (err) {
//       setError("Failed to check in");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCheckOut = async () => {
//     try {
//       setIsLoading(true);
//       const token = sessionStorage.getItem("token");
//       const decodedToken = JSON.parse(atob(token.split(".")[1]));
//       const employeeId = decodedToken.employee.id;

//       const response = await fetch(`${BASE_URL}/api/attendance/checkout`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ employeeId }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         setMessage(data.msg);
//         setError("");
//         setCheckInTime(null);
//       } else {
//         setError(data.message || "Check-out failed");
//       }
//     } catch (err) {
//       setError("Failed to check out");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="attendance-portal-container">
//       <Navbar />
//       <div className="main-content">
//         <Sidebar />
//         <div className="attendance-content">
//           <div className="attendance-card">
//             <div className="attendance-header">
//               <h2 className="attendance-title">Attendance Portal</h2>
//               <div className="date-day">
//                 <p className="current-date">
//                   {formattedDate}, {formattedDay}
//                 </p>
//               </div>
//             </div>

//             <div className="time-display-container">
//               <div className="time-display">
//                 <p className="time-label">Current Time</p>
//                 <p className="time-value">{formatTime(currentTime)}</p>
//               </div>

//               {/* <div className="time-display">
//                 <p className="time-label">Check-In Time</p>
//                 <p className="time-value">{formatTime(checkInTime)}</p>
//               </div> */}
//             </div>

//             <div className="attendance-actions">
//               {isLoggedIn ? (
//                 <>
//                   <button
//                     onClick={handleCheckIn}
//                     className="attendance-button checkin-button"
//                     disabled={isLoading}
//                   >
//                     {isLoading ? "Processing..." : "Check In"}
//                   </button>
//                   <button
//                     onClick={handleCheckOut}
//                     className="attendance-button checkout-button"
//                     disabled={isLoading}
//                   >
//                     {isLoading ? "Processing..." : "Check Out"}
//                   </button>
//                 </>
//               ) : (
//                 <p className="login-message">
//                   Please log in to manage attendance
//                 </p>
//               )}
//             </div>

//             <div className="attendance-messages">
//               {message && <p className="success-message">{message}</p>}
//               {error && <p className="error-message">{error}</p>}
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default AttendancePortal;





import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Navbar from "../common/Navbar";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BarChartIcon from "@mui/icons-material/BarChart";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Footer from "../common/Footer";
import Sidebar from "../common/Sidebar";
import { useNavigate } from "react-router-dom";
import check from "../../Assets/check.png";
import exit from "../../Assets/exit.png";


const BASE_URL = process.env.REACT_APP_BASE_URL;
const MAPS_CO_API_KEY =
  process.env.REACT_APP_MAPS_CO_API_KEY || "69eb4eed138cf453098986elo60550e";
let lastGeocodeRequest = 0;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const formatAddressFromParts = (locData) => {
  if (!locData || typeof locData !== "object") return null;
  const town =
    locData.city ||
    locData.town ||
    locData.village ||
    locData.hamlet ||
    locData.county ||
    locData.state_district ||
    "";
  const state = locData.state || "";
  const country = locData.country || "";
  const parts = [town, state, country].filter(Boolean);
  return parts.length ? parts.join(", ") : null;
};

const placeFromGeocodePayload = (data) => {
  if (data?.display_name) return data.display_name;
  if (data?.address) return formatAddressFromParts(data.address);
  return null;
};

const reverseWithNominatim = async (lat, lng) => {
  try {
    const now = Date.now();
    const sinceLast = now - lastGeocodeRequest;
    if (sinceLast < 1000) await sleep(1000 - sinceLast);
    lastGeocodeRequest = Date.now();

    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`,
      { headers: { "Accept-Language": "en" } }
    );
    if (!res.ok) return null;
    const data = await res.json();
    return placeFromGeocodePayload(data);
  } catch (e) {
    console.warn("[Geocoding] Nominatim failed:", e.message);
    return null;
  }
};

const reverseWithMapsCo = async (lat, lng) => {
  const key = (MAPS_CO_API_KEY || "").trim();
  if (!key) return null;
  try {
    const res = await fetch(
      `https://geocode.maps.co/reverse?lat=${lat}&lon=${lng}&api_key=${encodeURIComponent(key)}`
    );
    if (!res.ok) return null;
    const data = await res.json();
    return placeFromGeocodePayload(data);
  } catch (e) {
    console.warn("[Geocoding] Maps.co failed:", e.message);
    return null;
  }
};

const getCurrentPlaceLabel = async () => {
  if (!navigator.geolocation) return "Location unavailable";
  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      });
    });
    const { latitude: lat, longitude: lng } = position.coords;
    const primary = await reverseWithNominatim(lat, lng);
    if (primary) return primary;
    const fallback = await reverseWithMapsCo(lat, lng);
    if (fallback) return fallback;
    return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
  } catch (error) {
    console.warn("[Geocoding] Could not get current location:", error.message);
    return "Location unavailable";
  }
};

const AttendancePortal = () => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(!!sessionStorage.getItem("token"));
  const [currentTime, setCurrentTime] = useState(new Date());
  const [checkInTime, setCheckInTime] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [isClicked, setIsClicked] = useState(false);
  const [canCheckInFromOffice, setCanCheckInFromOffice] = useState(null);
  const [outsideModalOpen, setOutsideModalOpen] = useState(false);
  const [outsideModalType, setOutsideModalType] = useState("checkin"); // "checkin" | "checkout"
  const [outsideReason, setOutsideReason] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const today = new Date();
  const formattedDate = today
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();
  const formattedDay = today.toLocaleDateString("en-GB", { weekday: "long" });

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    fetchCheckInTime();
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const checkOfficeIp = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) return;
        const res = await fetch(`${BASE_URL}/api/attendance/can-checkin-from-office`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setCanCheckInFromOffice(data.allowed);
        }
      } catch (e) {
        console.warn("Could not check office IP:", e);
      }
    };
    checkOfficeIp();
  }, []);

  const formatTime = (date) => {
    if (!date) return "--:--:--";
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  const fetchCheckInTime = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return;

      const response = await fetch(`${BASE_URL}/api/attendance/checkin-time`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        setCheckInTime(data.checkInTime ? new Date(data.checkInTime) : null);
      }
    } catch (err) {
      console.error("Error fetching check-in time:", err);
    }
  };

  const handleCheckIn = async () => {
    const token = sessionStorage.getItem("token");
    try {
      setIsLoading(true);
      console.log("[Attendance] Check-in attempt started");

      // Fetch and log client IP as seen by server (for tracking)
      try {
        const ipRes = await fetch(`${BASE_URL}/api/attendance/client-ip`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (ipRes.ok) {
          const ipData = await ipRes.json();
          console.log("[Attendance] Client IP (as seen by server):", ipData.clientIp || ipData.raw || "unknown", ipData);
        }
      } catch (ipErr) {
        console.warn("[Attendance] Could not fetch client IP for log:", ipErr.message);
      }

      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const employeeId = decodedToken.employee.id;

      const currentLocation = await getCurrentPlaceLabel();
      const response = await fetch(`${BASE_URL}/api/attendance/checkin`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ employeeId, location: currentLocation }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("[Attendance] Check-in success:", data);
        setMessage(data.msg);
        setError("");
        setCheckInTime(new Date());
      } else {
        console.warn("[Attendance] Check-in failed:", response.status, data);
        setError(data.message || "Check-in failed");
      }
    } catch (err) {
      console.error("[Attendance] Check-in error:", err);
      setError("Failed to check in");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckOut = async () => {
    const token = sessionStorage.getItem("token");
    try {
      setIsLoading(true);
      console.log("[Attendance] Check-out attempt started");

      // Fetch and log client IP as seen by server (for tracking)
      try {
        const ipRes = await fetch(`${BASE_URL}/api/attendance/client-ip`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (ipRes.ok) {
          const ipData = await ipRes.json();
          console.log("[Attendance] Client IP (as seen by server):", ipData.clientIp || ipData.raw || "unknown", ipData);
        }
      } catch (ipErr) {
        console.warn("[Attendance] Could not fetch client IP for log:", ipErr.message);
      }

      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const employeeId = decodedToken.employee.id;

      const currentLocation = await getCurrentPlaceLabel();
      const response = await fetch(`${BASE_URL}/api/attendance/checkout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ employeeId, location: currentLocation }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("[Attendance] Check-out success:", data);
        setMessage(data.msg);
        setError("");
        setCheckInTime(null);
      } else {
        console.warn("[Attendance] Check-out failed:", response.status, data);
        setError(data.message || "Check-out failed");
      }
    } catch (err) {
      console.error("[Attendance] Check-out error:", err);
      setError("Failed to check out");
    } finally {
      setIsLoading(false);
    }
  };

  const openOutsideModal = (type) => {
    setOutsideModalType(type);
    setOutsideReason("");
    setOutsideModalOpen(true);
  };

  const handleOutsideSubmit = async () => {
    const r = (outsideReason || "").trim();
    if (!r) {
      setError("Please provide a reason.");
      return;
    }
    const token = sessionStorage.getItem("token");
    if (!token) return;
    setError("");
    setIsLoading(true);
    setOutsideModalOpen(false);
    try {
      const currentLocation = await getCurrentPlaceLabel();
      const url = outsideModalType === "checkin"
        ? `${BASE_URL}/api/attendance/checkin`
        : `${BASE_URL}/api/attendance/checkout`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          reason: r,
          location: currentLocation,
          isOutsideOffice: true,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.msg || "Success");
        if (data.pending) {
          // Do not set check-in/check-out time; user must wait for manager approval. Refresh page after approval to see updated state.
        } else {
          if (outsideModalType === "checkin") setCheckInTime(new Date());
          else setCheckInTime(null);
        }
      } else {
        setError(data.msg || data.message || (outsideModalType === "checkin" ? "Check-in failed" : "Check-out failed"));
      }
    } catch (err) {
      setError(outsideModalType === "checkin" ? "Failed to check in" : "Failed to check out");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F8FAFC",
      }}
    >
      <Navbar />

      <Box sx={{ display: "flex", flex: 1 }}>
        <Sidebar />

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column", // column so header + content stack
            px: { xs: 2, sm: 4 },
            py: 4,
            gap: 3,
          }}
        >
          {/* Header Section */}
          <Box sx={{ width: "100%", mt: 5 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Attendance Portal
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Use the panel below to Punch In and Punch Out for your workday.
            </Typography>
            <button
              type="button"
              onClick={() => navigate("/AttendanceRegularization")}
              style={{
                marginTop: "10px",
                padding: "8px 14px",
                borderRadius: "6px",
                border: "1px solid #1E40AF",
                background: "#fff",
                color: "#1E40AF",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Open Attendance Regularization
            </button>
          </Box>


          {/* Main Grid Row: Left + Right */}
       <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start", // ✅ Ensure both columns align to top
    gap: 4,
    flex: 1,
  }}
>
            {/* Left Section */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                order: { xs: 2, md: 1 },
                marginTop:"15px"
              }}
            >
              <Box sx={{ width: "100%", maxWidth: 500, p: 2 }}>
                {/* Orange Diamonds */}
                <Box sx={{ display: "flex", gap: 0.4, mb: 2 }}>
                  {Array.from({ length: 18 }).map((_, i) => (
                    <Box
                      key={i}
                      sx={{
                        width: 5,
                        height: 5,
                        transform: "rotate(45deg)",
                        backgroundColor:
                          i < 12
                            ? `rgba(100, 149, 237, ${1 - i * 0.04})` // cornflower blue with decreasing opacity
                            : "#7aaee9", // solid medium-light blue
                        borderRadius: 0.5,
                      }}
                    />
                  ))}
                </Box>



                {/* Heading */}
                <Typography variant="h6" fontWeight={600} sx={{ color: "#000", lineHeight: 1.1 }}>
                  Track attendance <br />
                  <Box component="span" sx={{ fontWeight: 300 }}>
                    employee work lifecycle
                  </Box>
                </Typography>

                {/* Subheading */}
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  sx={{
                    mt: 2,
                    mb: 4,
                    fontSize: "14px",
                    lineHeight: 1.5, // reduced line spacing
                  }}
                >
                  Seamlessly monitor employee attendance, leave balances, check-in trends,
                  and more to ensure streamlined workforce management and better
                  productivity insights.
                </Typography>


                {/* Feature Items */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 4,
                    mb: 4,
                    flexWrap: "nowrap",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, maxWidth: 400 }}>
                    <AccessTimeIcon sx={{ color: "primary.main", fontSize: 20, mt: "2px" }} />
                    <Box sx={{ maxWidth: 240 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                        Time Management
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Master your minutes—track attendance to manage time and boost productivity
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, maxWidth: 400 }}>
                    <BarChartIcon sx={{ color: "primary.main", fontSize: 20, mt: "2px" }} />
                    <Box sx={{ maxWidth: 240 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                        Stay Consistent
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Every check-in builds discipline, growth, and long-term success
                      </Typography>
                    </Box>
                  </Box>
                </Box>



              </Box>
            </Box>

            {/* Right Section */}
            
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                order: { xs: 1, md: 2 },
              }}
            >
              <Box
                sx={{
                  p: { xs: 3, sm: 4 },
                  borderRadius: 3,
                  width: "100%",
                  maxWidth: 600,
                  backgroundColor: "transparent", // fully transparent
                }}
              >
                <Box textAlign="center" mb={1}>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    color="primary.dark"
                    sx={{ letterSpacing: 2 }}
                  >
                    Attendance Panel
                  </Typography>

                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-around",
                    gap: 2,
                    mb: 4,
                  }}
                >
                  <Box
                    sx={{
                      // backgroundColor: "#1a1725", // Dark background
                      borderRadius: 2,
                      p: 2,
                      textAlign: "center",
                      flex: 1,
                      maxWidth: 220,
                      // boxShadow: "0 0 25px rgba(170, 136, 255, 0.4)", // subtle glow
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="#1a1725"
                      mb={2}
                      fontWeight={600}
                      sx={{
                        letterSpacing: 2,
                        '@media (max-width:600px)': {
                          textAlign: 'right', // only apply on xs
                        },
                      }}
                    >
                      Current Time
                    </Typography>


                    {/* Analog Clock */}
                    <Box
                      sx={{
                        width: 160,
                        height: 160,
                        backgroundColor: "white",
                        borderRadius: "50%",
                        position: "relative",
                        mx: "auto",
                        // On small screens, push it slightly to the right
                        transform: {
                          xs: "translateX(50px)", // phones
                          sm: "translateX(0)",    // tablets and above
                        },
                      }}
                    >

                      {/* Hour Hand */}
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "50%",
                          left: "50%",
                          width: "4px",
                          height: "40px",
                          backgroundColor: "black",
                          transformOrigin: "bottom",
                          transform: `rotate(${(currentTime.getHours() % 12) * 30 + currentTime.getMinutes() / 2}deg)`,
                          boxShadow: "0 0 8px #ffffff",
                        }}
                      />

                      {/* Minute Hand */}
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "50%",
                          left: "50%",
                          width: "2px",
                          height: "60px",
                          backgroundColor: "black",
                          transformOrigin: "bottom",
                          transform: `rotate(${currentTime.getMinutes() * 6}deg)`,
                          boxShadow: "0 0 6px #ffffff",
                        }}
                      />

                      {/* Second Hand */}
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "50%",
                          left: "50%",
                          width: "1px",
                          height: "70px",
                          backgroundColor: "#e066ff",
                          transformOrigin: "bottom",
                          transform: `rotate(${currentTime.getSeconds() * 6}deg)`,
                          boxShadow: "0 0 10px #e066ff",
                        }}
                      />
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={0.8}
                      sx={{
                        ml: { xs: 5, sm: -1 },
                        mb: 0,
                      }}
                    >
                      {/* Hours */}
                      <Box
                        sx={{
                          minWidth: 54,
                          minHeight: 54,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: 2,
                          mt: 1.5,
                          backgroundColor: "#f0f7ff",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          {(currentTime.getHours() % 12 || 12).toString().padStart(2, "0")}
                        </Typography>
                      </Box>

                      <Typography sx={{ mt: 1.5 }} variant="subtitle1" fontWeight="bold">:</Typography>

                      {/* Minutes */}
                      <Box
                        sx={{
                          minWidth: 54,
                          minHeight: 54,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: 2,
                          mt: 1.5,
                          backgroundColor: "#f0f7ff",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          {currentTime.getMinutes().toString().padStart(2, "0")}
                        </Typography>
                      </Box>

                      <Typography sx={{ mt: 1.5 }} variant="subtitle1" fontWeight="bold">:</Typography>

                      {/* Seconds */}
                      <Box
                        sx={{
                          minWidth: 54,
                          minHeight: 54,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: 2,
                          mt: 1.5,
                          backgroundColor: "#f0f7ff",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          {currentTime.getSeconds().toString().padStart(2, "0")}
                        </Typography>
                      </Box>

                      {/* AM/PM */}
                      <Typography variant="body2" ml={0.8} fontWeight={600}>
                        {currentTime.getHours() >= 12 ? "PM" : "AM"}
                      </Typography>
                    </Box>




                  </Box>

                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "row", sm: "row" },
                    justifyContent: {
                      xs: "space-between",
                      sm: "center",
                    },
                    alignItems: "center",
                    gap: { xs: 1, sm: 2 },
                    mb: { xs: 1, sm: 3 },
                    px: { xs: 2, sm: 0 },
                  }}
                >
                  {isLoggedIn ? (
                    <>
                      {/* Check In Button */}
                      <button
                        disabled={isLoading}
                        onClick={handleCheckIn}
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          backgroundColor: "#059669",
                          color: "#fff",
                          fontWeight: 600,
                          padding: "8px 16px",
                          minWidth: "110px",
                          width: "140px",
                          border: "none",
                          borderRadius: "6px",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          transition: "all 0.4s ease-in-out",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                        onMouseEnter={(e) => {
                          if (!isLoading) {
                            e.currentTarget.style.backgroundColor = "#065F46";
                            e.currentTarget.style.transform = "scale(1.04)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isLoading) {
                            e.currentTarget.style.backgroundColor = "#059669";
                            e.currentTarget.style.transform = "scale(1)";
                          }
                        }}
                      >
                        <img
                          src={check}
                          alt="Check"
                          style={{
                            width: "18px",
                            height: "22px",
                            filter: "brightness(0) invert(1)",
                            transform: "scale(1.05)", // Slightly larger
                          }}
                        />
                        {isLoading ? "Processing..." : "Check In"}
                      </button>

                      {/* Check Out Button */}
                      <button
                        disabled={isLoading}
                        onClick={handleCheckOut}
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          backgroundColor: "#DC2626",
                          color: "#fff",
                          fontWeight: 600,
                          padding: "8px 16px",
                          minWidth: "110px",
                          width: "140px",
                          border: "none",
                          borderRadius: "6px",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          transition: "all 0.4s ease-in-out",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          backgroundImage: "linear-gradient(135deg, #DC2626 40%, #ff758c 100%)",
                          backgroundSize: "200% 100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                        onMouseEnter={(e) => {
                          if (!isLoading) {
                            e.currentTarget.style.backgroundPosition = "right center";
                            e.currentTarget.style.transform = "scale(1.04)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isLoading) {
                            e.currentTarget.style.backgroundPosition = "left center";
                            e.currentTarget.style.transform = "scale(1)";
                          }
                        }}
                      >
                        <img
                          src={exit}
                          alt="Exit"
                          style={{
                            width: "18px",
                            height: "22px",
                            filter: "brightness(0) invert(1)", // ⬅️ Makes black icons white
                            transform: "scale(1.05)", // ⬅️ Slightly increase size for bold appearance
                          }}
                        />


                        {isLoading ? "Processing..." : "Check Out"}
                      </button>

                      {canCheckInFromOffice === false && (
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, width: "100%", mt: 2 }}>
                          <Typography variant="caption" color="text.secondary">
                            Not on office network? Check in/out from outside:
                          </Typography>
                          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "center" }}>
                            <button
                              type="button"
                              disabled={isLoading}
                              onClick={() => openOutsideModal("checkin")}
                              style={{
                                backgroundColor: "#f39c12",
                                color: "#fff",
                                fontWeight: 600,
                                padding: "8px 14px",
                                border: "none",
                                borderRadius: "6px",
                                cursor: isLoading ? "not-allowed" : "pointer",
                                fontSize: "13px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <LocationOnIcon sx={{ fontSize: 18 }} />
                              Check in from outside
                            </button>
                            <button
                              type="button"
                              disabled={isLoading}
                              onClick={() => openOutsideModal("checkout")}
                              style={{
                                backgroundColor: "#e67e22",
                                color: "#fff",
                                fontWeight: 600,
                                padding: "8px 14px",
                                border: "none",
                                borderRadius: "6px",
                                cursor: isLoading ? "not-allowed" : "pointer",
                                fontSize: "13px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <LocationOnIcon sx={{ fontSize: 18 }} />
                              Check out from outside
                            </button>
                          </Box>
                        </Box>
                      )}
                    </>
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      fontStyle="italic"
                    >
                      Please log in to manage attendance
                    </Typography>
                  )}
                </Box>


                <Box sx={{ textAlign: "center", minHeight: 24 }}>
                  {message && (
                    <Typography sx={{ color: "#059669", fontWeight: 500 }}>
                      {message}
                    </Typography>
                  )}
                  {error && (
                    <Typography sx={{ color: "error.main", fontWeight: 500 }}>
                      {error}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>

            <Dialog open={outsideModalOpen} onClose={() => setOutsideModalOpen(false)} maxWidth="sm" fullWidth>
              <DialogTitle>
                {outsideModalType === "checkin" ? "Check in from outside office" : "Check out from outside office"}
              </DialogTitle>
              <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Please provide a reason for this {outsideModalType === "checkin" ? "check-in" : "check-out"}.
                  Your current location is captured automatically.
                </Typography>
                <TextField
                  label="Reason"
                  placeholder="e.g. Client visit, WFH, Travel"
                  value={outsideReason}
                  onChange={(e) => setOutsideReason(e.target.value)}
                  fullWidth
                  required
                  sx={{ mb: 2 }}
                />
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 2 }}>
                <button
                  type="button"
                  onClick={() => setOutsideModalOpen(false)}
                  style={{
                    padding: "8px 16px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    background: "#fff",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleOutsideSubmit}
                  style={{
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "6px",
                    background: outsideModalType === "checkin" ? "#059669" : "#DC2626",
                    color: "#fff",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  {outsideModalType === "checkin" ? "Check In" : "Check Out"}
                </button>
              </DialogActions>
            </Dialog>

          </Box>
        </Box>
      </Box>

      <Footer />
    </Box>


  );
};

export default AttendancePortal;